module.exports = __webpack_public_path__ + "static/media/C5.91e8355d.png";